module.exports = __webpack_public_path__ + "img/ring_r_e_1_1.9a7fbe86.png";